angular.module('ihestiaWidgets.ikonfigurator')
  .controller('ikonfiguratorReadOfferModalCtrl', ['$scope', 'ikonfiguratorReadOfferModalHelper',
    function($scope, ikonfiguratorReadOfferModalHelper) {
      $scope.readOfferData = ikonfiguratorReadOfferModalHelper.readOfferData;
    }
  ]);